import { z as zod } from 'zod';
import { createErrorMap } from 'zod-validation-error';

const nameFormat = /^[A-Za-zА-Яа-яіІїЇєЄыЫ]+$/;
const contactNumberFormat = /^\+\d{1,3}\d{6,14}$/;

zod.config({
    customError: createErrorMap(),
});

export const JobApplyCheckUserSchema = zod.object({
    first_name: zod
        .string()
        .min(1, 'validation.required.name')
        .regex(nameFormat, 'validation.onlyLetter'),
    last_name: zod
        .string()
        .min(1, 'validation.required.surName')
        .regex(nameFormat, 'validation.onlyLetter'),
    email_address: zod.string().min(1, 'validation.required.email').email('Invalid email'),
    contact: zod
        .string()
        .min(1, 'validation.required.contact')
        .regex(contactNumberFormat, 'Invalid contact number'),
});
